import { useDispatch, useSelector, useStore } from 'react-redux';
var EMPTY_MAP = new Map();
var EMPTY_OBJECT = Object.freeze({});
var EMPTY_ARRAY = Object.freeze([]);
// https://react-redux.js.org/using-react-redux/usage-with-typescript#define-typed-hooks
// Defined in @deephaven/dashboard, as that's the most common package with React and @deephaven/redux as dependencies
// We could have another package specifically for this, but it's not really necessary.
export var useAppDispatch = useDispatch;
export var useAppSelector = useSelector;
export var useAppStore = useStore;

/**
 * Retrieve the data for all dashboards
 * @param store The redux store
 * @returns Property mapping dashboard ID to data for that dashboard
 */
export var getAllDashboardsData = store => store.dashboardData;

/**
 * @param store The redux store
 * @param dashboardId The dashboard ID to get data for
 * @returns The data object for the dashboard with the specified ID
 */
export var getDashboardData = (store, dashboardId) => {
  var _getAllDashboardsData;
  return (_getAllDashboardsData = getAllDashboardsData(store)[dashboardId]) !== null && _getAllDashboardsData !== void 0 ? _getAllDashboardsData : EMPTY_OBJECT;
};

/**
 * @param store The redux store
 * @param dashboardId The dashboard ID to get data for
 * @returns The ClosedPanel array of panels that were previously closed/dehydrated
 */
export var getClosedPanelsForDashboard = (store, dashboardId) => {
  var _getDashboardData$clo;
  return (_getDashboardData$clo = getDashboardData(store, dashboardId).closed) !== null && _getDashboardData$clo !== void 0 ? _getDashboardData$clo : EMPTY_ARRAY;
};

/**
 * @param store The redux store
 * @param dashboardId The dashboard ID to get data for
 * @returns The map of panel IDs to components of all currently open components
 */
export var getOpenedPanelMapForDashboard = (store, dashboardId) => {
  var _getDashboardData$ope;
  return (_getDashboardData$ope = getDashboardData(store, dashboardId).openedMap) !== null && _getDashboardData$ope !== void 0 ? _getDashboardData$ope : EMPTY_MAP;
};

/**
 * @param store The redux store
 * @param dashboardId The dashboard ID to get data for
 * @returns The map of plugin IDs to data for all plugins on the dashboard
 */
export var getPluginDataMapForDashboard = (store, dashboardId) => {
  var _getDashboardData$plu;
  return (_getDashboardData$plu = getDashboardData(store, dashboardId).pluginDataMap) !== null && _getDashboardData$plu !== void 0 ? _getDashboardData$plu : EMPTY_OBJECT;
};

/**
 * @param store The redux store
 * @param dashboardId The dashboard ID to get data for
 * @param pluginId The plugin ID to get data for
 * @returns The plugin data
 */
export var getPluginDataForDashboard = (store, dashboardId, pluginId) => getPluginDataMapForDashboard(store, dashboardId)[pluginId];
//# sourceMappingURL=selectors.js.map